<template>
    <div>
        <div class="mb-2">
            <v-card>
                <v-card-title>
                    Ventas Por Figura
                </v-card-title>
                <v-card-text v-if="params.juego_sorteo_id">
                    <Totalizador
                        v-if="params.juego_sorteo_id"
                        caption="SORTEO"
                        :loading="fetching"
                        :summary="report.summary.sorteo"
                        />
                    <Totalizador
                        caption="DÍA"
                        :loading="fetching"
                        :summary="report.summary.day"
                        />
                    <Totalizador
                        caption="SEMANA"
                        :loading="fetching"
                        :summary="report.summary.week"
                        />
                </v-card-text>
            </v-card>
        </div>
        <v-card>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="list"
                    :items-per-page="-1"
                    hide-default-footer
                    disable-pagination
                    disable-sort
                    disable-filtering
                    :expanded.sync="expanded"
                    :show-expand="showExpand"
                    :loading="fetching"
                    item-key="numero"
                    >
                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length" class="pa-1">
                            <div
                                v-for="(juegoPremio, index) in juego?.extra_loteria_juego_premio_list"
                                :key="`${item.numero}-juego-premio-reporte-${index}-${juegoPremio.id}`">
                                <ChildReport
                                    v-if="(!juegoPremio.metadata?.numero || (juegoPremio.metadata.numero == item.numero))"
                                    :params="{ ... params, numero: item.numero, on_juego_premio_id: juegoPremio.id }" 
                                    class="mb-1"
                                    :context="context"
                                    :limited="limited"
                                    >
                                    <v-chip small label>{{ juegoPremio.name }}</v-chip>
                                </ChildReport>
                            </div>
                        </td>
                    </template>
                    <!-- eslint-disable-next-line -->
                    <template v-slot:item.figura="{ item }">
                        <template v-if="limited">
                            <v-btn small text>
                                <div class="d-flex align-center">
                                    <v-avatar size="25" class="mr-2" v-if="item.figura.label">
                                        <img :src="item.figura.image" :alt="item.figura.value"/>
                                    </v-avatar>
                                    <div>
                                        {{ item.figura.value }} <template v-if="item.figura.label"> ~ {{ item.figura.label }}</template> <template v-if="item.ultimo_resultado">{{ (item.ultimo_resultado && `(${item.ultimo_resultado})`) || '' }}</template>
                                    </div>
                                </div>
                            </v-btn>
                        </template>
                        <template v-else>
                            <v-btn small text @click="open({
                                'comercio': 'reporte.figura',
                                'sistema': 'operadora.sistema.reporte.figura',
                            }[context], {
                                numero: item.figura.value
                            })">
                                <div class="d-flex align-center">
                                    <v-icon class="mr-2" small>mdi mdi-eye-outline</v-icon>
                                    <v-avatar size="25" class="mr-2" v-if="item.figura.label">
                                        <img
                                            :src="item.figura.image"
                                            :alt="item.figura.value"
                                            />
                                    </v-avatar>
                                    <div>
                                        {{ item.figura.value }} <template v-if="item.figura.label"> ~ {{ item.figura.label }}</template> <template v-if="item.ultimo_resultado">{{ (item.ultimo_resultado && `(${item.ultimo_resultado})`) || '' }}</template>
                                    </div>
                                </div>
                            </v-btn>
                        </template>
                    </template>
                    <!-- eslint-disable-next-line -->
                    <template v-slot:item.tickets="{ item }">
                        <template v-if="limited">
                            <v-btn small class="mr-2" text>
                                <v-icon class="mr-2" small>mdi mdi-receipt-text</v-icon>
                                {{ item.count }}
                            </v-btn>
                        </template>
                        <template v-else>
                            <v-btn small class="mr-2" text @click="open({
                                'comercio': 'tickets',
                                'sistema': 'operadora.sistema.tickets',
                            }[context], {
                                numero: item.figura.value
                            })">
                                <v-icon class="mr-2" small>mdi mdi-receipt-text</v-icon>
                                {{ item.count }}
                            </v-btn>
                        </template>
                    </template>
        
                    <!-- eslint-disable-next-line -->
                    <template v-slot:item.venta="{ item }">
                        {{ item.venta | currency(item.divisa_code) }}
                    </template>
                    <!-- eslint-disable-next-line -->
                    <template v-slot:item.comision="{ item }">
                        {{ item.comision | currency(item.divisa_code) }}
                    </template>
                    <!-- eslint-disable-next-line -->
                    <template v-slot:item.projected="{ item }">
                        <v-chip small label :color="item.premioColor" class="font-weight-bold mr-2">
                            {{ item.projected | currency(item.divisa_code) }} {{' / '}} {{ item.percent_premio | percent }}
                        </v-chip>
                    </template>
                    <!-- eslint-disable-next-line -->
                    <template v-slot:item.total_projected="{ item }">
                        <v-chip small label :color="item.sorteoColor" class="font-weight-bold mr-2">
                            Sorteo <v-divider vertical class="mx-3"/> {{ item.related.sorteo.total | currency(item.divisa_code) }}
                        </v-chip>
                        <v-chip small label :color="item.dayColor" class="font-weight-bold mr-2">
                            Día <v-divider vertical class="mx-3"/> {{ item.related.day.total | currency(item.divisa_code) }}
                        </v-chip>
                        <v-chip small label :color="item.weekColor" class="font-weight-bold">
                            Semana <v-divider vertical class="mx-3"/> {{ item.related.week.total | currency(item.divisa_code) }}
                        </v-chip>
                    </template>
                    
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import ReportePorFiguraService from '@/services/reporte/ventas/ReportePorFiguraService';

import Totalizador from '@components/entities/reporte/venta/figura/totalizador';
import ChildReport from './childreport.vue';

const reportDefault = {
    summary: {},
    detail: [],
};

export default {
    components: {
        Totalizador,
        ChildReport
    },
    props: {
        params: {
            defaults: function() {
                return {

                };
            },
        },
        context: {
            default: 'comercio',
        },
        loading: {
            type: Boolean,
            default: true,
        },
        limited: {
            type: Boolean,
            default: false,
        },
        juego: {}
    },
    data: function() { 
        return {
            report:  { ... reportDefault },
            fetching: true,
            expanded: [],
        }
    },
    computed: {
        divisa: function () {
            return this.$store.getters['persist/divisa/selected'];
        },
        reportComputed: function () {
            return this.report;
        },
        list: function () {
            return this.report.detail.map(report => {
                return {
                    ...report,
                    premioColor: report.percent_premio <= 1 ? 'primary': 'error',
                    sorteoColor: report.related.sorteo.total == 0 
                                    ? 'secondary' 
                                    : report.related.sorteo.total > 0 
                                        ? 'primary'
                                        : 'error',
                    dayColor: report.related.day.total == 0 
                                    ? 'secondary' 
                                    : report.related.day.total > 0 
                                        ? 'primary'
                                        : 'error',
                    weekColor: report.related.week.total == 0 
                                    ? 'secondary' 
                                    : report.related.week.total > 0 
                                        ? 'primary'
                                        : 'error',
                }
            })
        },
        summary: function () {
            return this.report.summary;
        },
        headers: function () {
            const prepend = [];

            if (this.showExpand) {
                prepend.push({ text: '', value: 'data-table-expand' });
            }

            return [
                ... prepend,
                { 
                    text: 'Figura',
                    align: 'start',
                    value: 'figura',
                    width: 90 
                },
                { 
                    text: 'Tickets',
                    align: 'start',
                    value: 'tickets' 
                },
                { 
                    text: 'Ventas',
                    align: 'center',
                    value: 'venta' 
                },
                { 
                    text: 'Comisión',
                    align: 'center',
                    value: 'comision' 
                },
                { 
                    text: 'Premio',
                    align: 'center',
                    value: 'projected' 
                },
                { 
                    text: 'Total',
                    align: 'start',
                    value: 'total_projected' 
                },
            ];
        },
        showExpand: function () {
            if (this.juego?.tipo_juego?.slug == 'triple') return false;
            return !!(this.juego?.extra_loteria_juego_premio_list?.length);
        }
    },
    methods: {
        getLegibleDistanciaFecha: function (date) {
            if (!date) return 0;

            const start = this.$luxon.fromSQL(date);
            const end = this.$luxon.now();

            const days = Math.floor(end.diff(start, 'days').toObject().days);

            return days;
        },
        fetchReport: function (params = {}) {
            this.report = { ... reportDefault };
            this.expanded = [];

            this.fetching = true;

            const parameters = {...this.params, ...params, divisa_id: this.divisa.id};

            if (this.context == 'sistema') {
                parameters['group_by'] = 'sistema';
                parameters['comercio_type'] = 'sistema';
            }

            ReportePorFiguraService.getConsolidado(parameters)
                .then(({ report }) => {
                    this.report = report;
                }).finally(() => {
                    this.fetching = false;
                });
        },
        open: function (route, filters, context = 'tab') {
            const comercio = filters.comercio;
            delete filters.comercio;
            
            const query = {
                ... this.params,
                ... filters,
            };
            
            if (comercio) query[`${comercio.comercio_type}_id`] = comercio.comercio_id;
            
            const $route = this.$router.resolve({
                name: route,
                query: query,
            });

            if (context == 'tab') return window.open(new URL($route.href, window.location.origin), '_blank').focus();
            if (context == 'window') return window.open(new URL($route.href, window.location.origin), '_blank', 'titlebar=no, status=no, menubar=no, height=600 width=1000');
        }
    },
    watch: { 
        'params': function () {
            this.fetchReport();
        },
        'divisa': function () {
            this.fetchReport();
        },
        'fetching': function (fetching) {
            this.$emit('update:loading', fetching);
        }
    },
    mounted: function () {
        this.$emit('update:loading', this.fetching);
        this.fetchReport();
    }
}
</script>
<style>

</style>